var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup46(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#233155;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-500 -500)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6,
    height: 2,
    transform: "translate(508 505)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5,
    height: 2,
    transform: "translate(508 509)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6,
    height: 2,
    transform: "translate(508 513)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M520,518v-4.757l.243-.243H522v-1.757L523.243,510,522,508.757V507h-1.757l-.243-.243V503a3,3,0,0,0-3-3H503a3,3,0,0,0-3,3v4h4v14a3,3,0,0,0,3,3h14a3,3,0,0,0,3-3v-3Zm-16-13h-2v-2a1,1,0,0,1,2,0Zm15,3.586.414.414H520v.586l.414.414-.414.414V511h-.586l-.414.414-.414-.414H518v-.586l-.414-.414.414-.414V509h.586ZM508,521a1,1,0,0,1-2,0V503a2.966,2.966,0,0,0-.184-1H517a1,1,0,0,1,1,1v3.757l-.243.243H516v1.757L514.757,510,516,511.243V513h1.757l.243.243V518H508Zm14,0a1,1,0,0,1-1,1H509.829a3.009,3.009,0,0,0,.171-1v-1h12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup46);
export default __webpack_public_path__ + "static/media/Group 46.138fe96c6d3a3a3e57f3285b3f0cfc78.svg";
export { ForwardRef as ReactComponent };